import moment from 'moment';

import { IOptionalDateWindow, IOptionalTimeWindow } from '../../types/datetimes';

export function getVisitSortDate({
    startDatetime,
    tentativeDate,
    fulfillmentWindow,
    preferredTimeslots,
}: {
    startDatetime?: Date | null;
    tentativeDate: Date | null;
    fulfillmentWindow: IOptionalTimeWindow | IOptionalDateWindow | null;
    preferredTimeslots?:
        | {
              startDatetime: Date;
              endDatetime: Date;
          }[]
        | null;
}): Date | null {
    if (startDatetime) {
        return startDatetime;
    }
    if (tentativeDate) {
        return tentativeDate;
    }
    if (fulfillmentWindow) {
        let start;
        let end;
        if ('startDatetime' in fulfillmentWindow) {
            start = fulfillmentWindow.startDatetime
                ? moment(fulfillmentWindow.startDatetime)
                : null;
            end = fulfillmentWindow.endDatetime ? moment(fulfillmentWindow.endDatetime) : null;
        }
        if ('startDate' in fulfillmentWindow && 'endDate' in fulfillmentWindow) {
            start = fulfillmentWindow.startDate
                ? moment(fulfillmentWindow.startDate).startOf('day')
                : null;
            end = fulfillmentWindow.endDate ? moment(fulfillmentWindow.endDate).endOf('day') : null;
        }
        if (start && end) {
            const numHours = end.diff(start, 'hours') / 2;
            const midpoint = start.clone().add(numHours, 'hours');
            return midpoint.toDate();
        }
        if (start) {
            return start.toDate();
        }
        if (end) {
            return end.toDate();
        }
    }
    if (preferredTimeslots && preferredTimeslots.length > 0) {
        return preferredTimeslots[0].startDatetime;
    }
    return null;
}

export function getEffectiveVisitDateLabel({
    startDatetime,
    tentativeDate,
    fulfillmentWindow,
}: {
    startDatetime?: Date | null;
    tentativeDate: Date | null;
    fulfillmentWindow: IOptionalTimeWindow | null;
}): string | null {
    if (startDatetime) {
        return 'Visit Date';
    }
    if (fulfillmentWindow && isTimeWindowSingleDay(fulfillmentWindow)) {
        return 'Visit Date';
    }
    if (tentativeDate) {
        return 'Tentative Date';
    }
    if (fulfillmentWindow) {
        return 'Date Range';
    }
    return null;
}

export function isTimeWindowSingleDay(timeWindow: IOptionalTimeWindow) {
    const { startDatetime, endDatetime } = timeWindow;
    if (startDatetime && endDatetime) {
        return moment(startDatetime).isSame(moment(endDatetime), 'day');
    }
    return false;
}

export function getTimeWindowSingleDay(timeWindow: IOptionalTimeWindow) {
    const { startDatetime } = timeWindow;
    if (isTimeWindowSingleDay(timeWindow)) {
        return startDatetime;
    }
    return null;
}

export function isDateWindowSingleDay(dateWindow: IOptionalDateWindow) {
    const { startDate, endDate } = dateWindow;
    if (startDate && endDate) {
        return moment(startDate).isSame(moment(endDate), 'day');
    }
    return false;
}
